import { defineComponent as S, inject as h, h as r } from "vue";
import { drawerInjectionKey as p } from "./ghl-ui.es989.js";
import { throwError as w } from "./ghl-ui.es853.js";
import g from "./ghl-ui.es859.js";
import u from "./ghl-ui.es994.js";
const v = {
  title: String,
  headerClass: String,
  headerStyle: [Object, String],
  footerClass: String,
  footerStyle: [Object, String],
  bodyClass: String,
  bodyStyle: [Object, String],
  bodyContentClass: String,
  bodyContentStyle: [Object, String],
  nativeScrollbar: {
    type: Boolean,
    default: !0
  },
  scrollbarProps: Object,
  closable: Boolean
}, N = S({
  name: "DrawerContent",
  props: v,
  setup() {
    const t = h(p, null);
    t || w("drawer-content", "`n-drawer-content` must be placed inside `n-drawer`.");
    const {
      doUpdateShow: e
    } = t;
    function l() {
      e(!1);
    }
    return {
      handleCloseClick: l,
      mergedTheme: t.mergedThemeRef,
      mergedClsPrefix: t.mergedClsPrefixRef
    };
  },
  render() {
    const {
      title: t,
      mergedClsPrefix: e,
      nativeScrollbar: l,
      mergedTheme: n,
      bodyClass: i,
      bodyStyle: c,
      bodyContentClass: a,
      bodyContentStyle: s,
      headerClass: b,
      headerStyle: y,
      footerClass: C,
      footerStyle: f,
      scrollbarProps: m,
      closable: d,
      $slots: o
    } = this;
    return r("div", {
      role: "none",
      class: [`${e}-drawer-content`, l && `${e}-drawer-content--native-scrollbar`]
    }, o.header || t || d ? r("div", {
      class: [`${e}-drawer-header`, b],
      style: y,
      role: "none"
    }, r("div", {
      class: `${e}-drawer-header__main`,
      role: "heading",
      "aria-level": "1"
    }, o.header !== void 0 ? o.header() : t), d && r(g, {
      onClick: this.handleCloseClick,
      clsPrefix: e,
      class: `${e}-drawer-header__close`,
      absolute: !0
    })) : null, l ? r("div", {
      class: [`${e}-drawer-body`, i],
      style: c,
      role: "none"
    }, r("div", {
      class: [`${e}-drawer-body-content-wrapper`, a],
      style: s,
      role: "none"
    }, o)) : r(u, Object.assign({
      themeOverrides: n.peerOverrides.Scrollbar,
      theme: n.peers.Scrollbar
    }, m, {
      class: `${e}-drawer-body`,
      contentClass: [`${e}-drawer-body-content-wrapper`, a],
      contentStyle: s
    }), o), o.footer ? r("div", {
      class: [`${e}-drawer-footer`, C],
      style: f,
      role: "none"
    }, o.footer()) : null);
  }
});
export {
  N as default,
  v as drawerContentProps
};
